import {Col, Row, Back} from "@bezlimit/bezlimit-ui";
import {useNavigate} from "react-router-dom";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";
// components
import PassportForm from "./passportForm";

export default observer(function VerificationPage() {
    const navigate = useNavigate();

    return (
        <>
            <Row justify="center" gutter={32}>
                <Back navigate={() => navigate("/reservation")}>Назад в Брони</Back>

                <Col lg={{span: 24}} xs={{span: 24}}>
                    <PassportForm />
                </Col>
            </Row>
        </>
    );
});
